import {IBetWayWinData} from "@nolimitcity/slot-game/bin/utils/server/IData";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export enum DumpsterFireWinTypes {
    TINY = "tiny",
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large",
    BIG_WIN_01 = "bigWin01",
    BIG_WIN_02 = "bigWin02",
    BIG_WIN_03 = "bigWin03",
    BIG_WIN_04 = "bigWin04",
    BIG_WIN_05 = "bigWin05"
}

export interface IWinRatioConfig {
    readonly ratio: number;
    readonly duration: number;
    readonly type: string;
}

export interface IBigWinLevel extends IWinRatioConfig {
    readonly from: number;
    to: number;
    readonly id: number;
}

export interface IWinRatios {
    readonly normalWin: IWinRatioConfig[];
    readonly bigWin: IBigWinLevel[];
}

export interface DumpsterFireData {
    mode: string;
    nextMode: string;
    reels: string[][]
    accumulatedRoundWin: number;
    positionMultipliers: number[][];
    positionMultipliersAtStart: number[][],
    positionMultipliersPostXWays: number[][];
    xWaysMultipliers: number[][],
    xWaysSymbol: string,
    upgradedSymbols: string[]
    wasFeatureBuy: boolean;
    nextPlayerInteraction: any;
    extraSpinCost: number,
    freespinsPlayed: number,
    extraSpinCount: number,
    freespinsLeft: number,
    luckyWheelStop: number,
    boostedBet: boolean,
    serverTestInfo: string,
    isRestoreState: boolean,
    brokeTheBank: boolean
}

export interface DumpsterFireInitData extends DumpsterFireData {
    isRestoreState: boolean;
    scatterWins: IBetWayWinData[];
    featureBuyTimesBetValue: FeatureBuyTimesBetValue[];
    symbolValues: ISymbolValues
}

export interface ISymbolValues {
    [symbolName: string]: { [numSymbols: number]: number };
}

export interface DumpsterFireGameData extends DumpsterFireData {
    playedBetValue: number;
    reelsAfterAvalanche: string[][];
    accumulatedRoundWin: number;
    spinWin: number;
    wasFeatureBuy: boolean;
    gambleCollect: boolean;
    gambleOptions: any;
    gambleSuccess: boolean;
    freespinsLeft: number;
    scatterWins: IBetWayWinData[];
    evaluatedReels: string[][];
    brokeTheBank: boolean;
    xWaysSymbol: string
}